module.exports = __webpack_public_path__ + "img/pr-2.c1a67e49.png";